<template>
    <button class="snipcart-add-item"
      :data-item-id="item.id"
      :data-item-price="item.price"
      data-item-url="/static/v1/products.json"
      :data-item-description="item.description"
      :data-item-image="item.image_url"
      data-item-custom1-name="Size"
      data-item-custom1-options="Small|Medium|Large"
      :data-item-name="`${item.name} - ${item.color}`">
    <i class="ti-shopping-cart"></i> ADD TO CART
    </button>
</template>
<script>
export default {
  name: 'BuyButton',
  props: ['item']
}
</script>
<style scoped>
.snipcart-add-item {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/BuyButton.vue